import RestError from '../app/errors';

export default class OutdatedPriceError extends RestError {}
